import { MEETINGS_PUBLIC_URL } from "@/config";
import { TUser } from "@/models/user.model";
import { SESSION_STATUS_IN_PROGRESS, SESSION_STATUS_INTRO_VIDEO, SESSION_STATUS_WAITING } from "@icebergeradmin/common";

export const getSessionStatusName = (sessionStatus: number) => {
  switch (sessionStatus) {
    case SESSION_STATUS_INTRO_VIDEO:
      return "Intro Video";
    case SESSION_STATUS_WAITING:
      return "Waiting";
    case SESSION_STATUS_IN_PROGRESS:
      return "In Progress";
    default:
      return "Unkown status";
  }
};


export const formatSessionDuration = (seconds: number): string => {
  const totalSeconds = Math.floor(seconds);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const secs = totalSeconds % 60;

  const hoursStr = hours.toString().padStart(2, '0');
  const minutesStr = minutes.toString().padStart(2, '0');
  const secsStr = secs.toString().padStart(2, '0');

  return `${hoursStr}:${minutesStr}:${secsStr}`;
}

export const getFullPersonalRoomUrl = (user: TUser) => `${MEETINGS_PUBLIC_URL}/${user.companyUniqueName}/${user.personalRoomId}`;
/* ── IronPipeline redesign helpers ────────────────────────────────────────── */

// Accent palette for deterministic avatar colors (presentation only).
const AVATAR_PALETTE = ["#3B82F6", "#A855F7", "#EC4899", "#F59E0B", "#06B6D4", "#22C55E"];

export const avatarColor = (name: string): string => {
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
  return AVATAR_PALETTE[Math.abs(hash) % AVATAR_PALETTE.length];
};

// AI transcript speaker labels are free text (e.g. "Agent", "Sales Rep",
// a first name) — this heuristic is the shared way to bucket a line as the
// agent vs. the lead across the transcript tab and the audio player's
// speaker visualization.
export const isAgentSpeaker = (speaker: string): boolean =>
  speaker.toLowerCase().includes('agent') || speaker.toLowerCase().includes('sales');

/** "hh:mm:ss" → "1h 23m" | "17m" | "45s" (leaderboard display) */
export const formatDurationCompact = (hhmmss: string): string => {
  const [h = 0, m = 0, s = 0] = hhmmss.split(":").map(Number);
  if (h > 0) return `${h}h ${m}m`;
  if (m > 0) return `${m}m`;
  return `${s}s`;
};
